import { AccountDatasource } from './../../../../lib/user_app/datasources/account_datasource';
import { ILog } from './../../types';
import { ILocalDatabase } from 'utility-ts-database';
import { IPhxStateService } from 'utility-ng-configuration';
import { IPhxPromptDelegate } from './../../components/phx_prompt/phx_prompt';
import { ICommand } from 'core-ts-types';

export class SessionWarningController {
  private open: boolean = true;
  private timeout = this.ngAccountDatasource.account.ttl_lead_time_in_seconds + 's';
  sessionWarningModalTimerDelegate: any;
  userSessionTimerDelegate: any;
  countdown: string;

  constructor(
    public $state: IPhxStateService,
    private ngAccountDatasource: AccountDatasource,
    private logoutCommand: ICommand,
    private logoutAnonymousCommand: ICommand,
    private logoutNotificationCommand: ICommand,
    private log: ILog,
    public sessionTimerDelegate: any,
    public phxPromptDelegate: IPhxPromptDelegate,
    private heartBeatCommand: ICommand,
    private localDatabase: ILocalDatabase
  ) {
    this._initialize(sessionTimerDelegate);
  }

  private _initialize(sessionTimerDelegate: any): void {
    this.sessionWarningModalTimerDelegate = sessionTimerDelegate.handle('modalSessionWarning');
    this.userSessionTimerDelegate = sessionTimerDelegate.handle('userSession');
  }

  isAnonymousUserMessage(): boolean {
    return (
      this.ngAccountDatasource.isAnonymous() && this.$state.__previousRoute__.state.name !== 'my.reset_password.set_new'
    );
  }

  isAdminUserMessage(): boolean {
    return (
      this.ngAccountDatasource.account.is_transfer_admin ||
      this.ngAccountDatasource.account.is_transfer_counselor ||
      this.ngAccountDatasource.account.is_transfer_analytics_user
    );
  }

  modalOnTick(count: number): void {
    const minutes = Math.floor(count / 60);
    const seconds = count - minutes * 60;
    this.countdown = minutes > 0 ? `${minutes} minutes ${seconds} seconds` : `${seconds} seconds`;

    this.localDatabase
      .open()
      .then(() => {
        return this.localDatabase.get(this.ngAccountDatasource.account.id);
      })
      .then((account) => {
        if (account.expire_time !== this.ngAccountDatasource.account.expire_time) {
          this.ngAccountDatasource.account.expire_time = account.expire_time;
          this.userSessionTimerDelegate.restartSession();
          this.open = false;
        }
      });
  }

  modalCountdownCallBack(): void {
    this.$state.go('landing').then(() => {
      this.ngAccountDatasource.isAnonymous() ? this.logoutAnonymousCommand() : this.logoutCommand();
      this.log.user.warn({
        name: `log-out-message`,
        content: `For your security, you have been logged out due to inactivity.`,
        dismissOnTimeout: false,
        dismissOnClick: true,
        dismissButton: true
      });
    });
  }

  keepWorking(): void {
    this.open = false;
  }

  logout(): void {
    this.logoutNotificationCommand();
  }

  makeAPICallToKeepAlive(): void {
    this.heartBeatCommand();
  }

  openedChanged(event: any) {
    if (!event.detail.value) {
      this.makeAPICallToKeepAlive();
      this.$state.__goToPrevious__();
    }
  }
}

angular
  .module('capability-ng-global')
  .controller('ngSessionWarningController', SessionWarningController)
  .directive('sessionWarning', function(): ng.IDirective {
    return {
      restrict: 'E',
      replace: false,
      controller: 'ngSessionWarningController',
      controllerAs: '$ctrl',
      templateUrl: 'lib/global/prompts/session_warning/session_warning.html',
      scope: {},
      compile: function(element: ng.IAugmentedJQuery): void {
        element.addClass('session-warning-modal');
      }
    };
  });



// WEBPACK FOOTER //
// ./app/lib/global/prompts/session_warning/session_warning.ts